import { useEventListener } from '@vueuse/core';
import { useDeviceSize } from '@/js/composables/useDeviceSize';
import useTippyPopup from '@/js/composables/useTippyPopup';

const { isMobileOrTablet } = useDeviceSize();

if (isMobileOrTablet.value) {
    const links = document.querySelectorAll<HTMLAnchorElement>('.tippy-author');

    links.forEach((link) => {
        useEventListener(link, 'click', (event) => {
            event.preventDefault();
        });
    });
}

const authors = document.querySelectorAll<HTMLElement>('.tippy-author');

authors.forEach((author) => {
    useTippyPopup(author, {
        isContentReactive: true,
        content(reference) {
            const id = reference.getAttribute('data-template');

            if (!id) {
                return null;
            }

            const template = document.getElementById(id);

            if (!template) {
                return null;
            }

            const clonedTemplate = template.cloneNode(true) as HTMLElement;

            clonedTemplate.style.display = 'block';

            return clonedTemplate;
        },
        placement: 'bottom',
        interactive: true,
        trigger: isMobileOrTablet.value ? 'click' : 'mouseenter focus',
    });
});
